import Alert from "@mui/material/Alert";
import { useSelector } from "react-redux";
import { selectStatus } from "../ducks/app/connection/selectors";
import { useTranslation } from "react-i18next";

const ErrorMessages = () => {
  const status = useSelector(selectStatus);
  const { t } = useTranslation("translation");
  switch (status) {
    case "ERROR":
      return <Alert severity="error">{t("technicalError")}</Alert>;
    case "OK":
      return null;
    default:
      return null;
  }
};

export default ErrorMessages;
